export const SET_QUESTNO_IQ = 'SET_QUESTNO_IQ';
export const SET_FROM_IQ_REDIRECT = 'SET_FROM_IQ_REDIRECT';
export const SET_SERVICES = 'SET_SERVICES';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const SET_TRANSACTION_ITEMS = 'SET_TRANSACTION_ITEMS';
export const SET_CHANGEITEMS_RESULT = 'SET_CHANGEITEMS_RESULT';
export const RESET_CHANGEITEMS_RESULT = 'RESET_CHANGEITEMS_RESULT';
export const SET_APLCATL = 'SET_APLCATL';
export const SET_VALID_EMAIL_ARRAY = 'SET_VALID_EMAIL_ARRAY';
export const mutations = {
    [SET_QUESTNO_IQ](state, payload) {
        state.questNoIQ = payload;
    },
    [SET_FROM_IQ_REDIRECT](state, payload) {
        state.fromIQRedirect = payload;
    },
    [SET_TRANSACTION_ITEMS](state, payload) {
        state.transactionItems = payload;
    },

    [SET_SERVICES](state, payload) {
        state.serviceList = payload;
    },
    // 刪除一項變更
    [REMOVE_SERVICE](state, { code, commit }) {
        state.transactionItems.forEach(item => {
            if (item.transactionItemNo === code) {
                item.userChecked = false;
                item.confirm = false;
            }
        });
        state.serviceList = state.serviceList.filter(i => i.transactionItemNo !== code);
        const keys = Object.keys(state.changeItemsResult);
        const codeKeys = keys.filter(i => i.substr(0, 2) === code);
        codeKeys.forEach(i => {
            delete state.changeItemsResult[i];
        });

        commit(RESET_CHANGEITEMS_RESULT, state.changeItemsResult);
        commit(SET_TRANSACTION_ITEMS, state.transactionItems);
        commit(SET_SERVICES, state.serviceList);
    },

    [SET_CHANGEITEMS_RESULT](state, payload) {
        const { code, value } = payload;
        state.changeItemsResult[code] = value;
    },

    [RESET_CHANGEITEMS_RESULT](state, payload) {
        state.changeItemsResult = payload;
    },
    [SET_APLCATL](state, payload) {
        state.aplCatl = payload;
    },
    [SET_VALID_EMAIL_ARRAY](state, payload) {
        state.validEmailArray = payload;
    },
};
